import { httpClient } from 'api';
import { ApplicationWithContactInfo } from 'types/Application';
import { Paginated } from 'types/Paginated';
import { Pair } from 'types/Pair';
import { PairingQueueResponse } from 'types/Pairing';
import { PairChangelogEntry } from '../types/Changelog';

export const pairsApi = {
	// adminDownloadPairsXML: ({ programId }: { programId: number }) =>
	// 	axiosInstance.get<string>(`pairs/admin/${programId}/xml`),
	adminDownloadPairsXLS: ({ programId }: { programId: number }) =>
		httpClient.get<Blob>(`pairs/admin/${programId}/xls`, undefined, { responseType: 'blob' }),
	adminDownloadPairProposalsXLS: ({ programId }: { programId: number }) =>
		httpClient.get<Blob>(`pairs/admin/${programId}/xls/proposals`, undefined, { responseType: 'blob' }),
	adminChangePairStatus: ({ programId, pairId, payload }: { programId: number; pairId: number; payload: string }) =>
		httpClient.put<any>(`pairs/admin/${programId}/pair/${pairId}`, { status: payload }),
	getApplicationAreas: ({ applicationRole, membershipId }: { applicationRole: string; membershipId: number }) =>
		httpClient.get<Array<{ title: string; options: string[] }>>(
			`pairs/browse/application/${applicationRole}/${membershipId}`
		),
	getPairLastChange: ({ programId, pairId }: { programId: number; pairId: number }) =>
		httpClient.get<PairChangelogEntry | null>(`programs/admin/${programId}/pair/${pairId}/changelog/last`),

	getPairChangelogHistory: ({ programId, pairId }: { programId: number; pairId: number }) =>
		httpClient.get<PairChangelogEntry[]>(`programs/admin/${programId}/pair/${pairId}/changelog`),
	adminManageSignature: ({
		programId,
		pairId,
		action,
		target,
		role,
	}: {
		programId: number;
		pairId: number;
		action: 'cancel' | 'restore';
		target: 'contract' | 'plan';
		role: 'mentee' | 'mentor';
	}) =>
		httpClient.put<any>(`pairs/admin/${programId}/pair/${pairId}/signature`, {
			action,
			target,
			role,
		}),
	getBrowsePotentialPairs: ({
		applicationRole,
		membershipId,
		filter,
		page,
	}: {
		applicationRole: string;
		membershipId: number;
		filter: any;
		page: number;
	}) =>
		httpClient.get<Paginated<ApplicationWithContactInfo>>(`pairs/browse/list/${applicationRole}/${membershipId}`, {
			page,
			filter,
		}),
	makeContact: ({
		applicationRole,
		membershipId,
		applicationId,
	}: {
		applicationRole: string;
		membershipId: number;
		applicationId: number;
	}) => httpClient.put<Pair>(`pairs/browse/make-contact/${applicationRole}/${membershipId}/${applicationId}`),
	getProgramPairingQueue: ({ programId }: { programId: number }) =>
		httpClient.get<PairingQueueResponse>(`programs/admin/${programId}/pairing/proposals`),
	acceptProgramPairingProposal: ({ programId, pairId }: { programId: number; pairId: number }) =>
		httpClient.post<void>(`programs/admin/${programId}/pair/${pairId}`),
	reserveProgramPairingProposal: ({ programId, pairId }: { programId: number; pairId: number }) =>
		httpClient.put<{ reserved: boolean }>(`programs/admin/${programId}/pair/${pairId}`),
	rejectProgramPairingProposal: ({ programId, pairId }: { programId: number; pairId: number }) =>
		httpClient.delete<void>(`programs/admin/${programId}/pair/${pairId}`),
};
